module.exports = __webpack_public_path__ + "static/media/Emma.8fbcbc74.jpg";